import { Link } from "react-router-dom";
import { cn } from "@/lib/utils/cn";
import type { TopicSummary } from "@/types";

interface TopicPillProps {
  topic: TopicSummary;
  size?: "xs" | "sm" | "md";
  showSubscriberCount?: boolean;
  className?: string;
}

export function TopicPill({ topic, size = "sm", showSubscriberCount, className }: TopicPillProps) {
  const sizeClasses = {
    xs: "text-2xs px-2 py-0.5 gap-1",
    sm: "text-xs px-2.5 py-1 gap-1.5",
    md: "text-sm px-3 py-1.5 gap-2",
  };

  const dotSizes = { xs: "w-1.5 h-1.5", sm: "w-2 h-2", md: "w-2.5 h-2.5" };

  return (
    <Link to={`/topics/${topic.slug}`}
      className={cn(
        "inline-flex items-center rounded-full font-medium",
        "border border-border bg-surface-overlay text-text-muted",
        "hover:border-brand/50 hover:text-brand hover:bg-brand-muted",
        "transition-all duration-150",
        sizeClasses[size],
        className
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <span
        className={cn("rounded-full flex-shrink-0", dotSizes[size])}
        style={{ backgroundColor: topic.color }}
      />
      {topic.name}
      {topic.is_verified && (
        <svg className="w-3 h-3 text-brand" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />
        </svg>
      )}
    </Link>
  );
}
